<template>
  <generic-modal v-if="visible"
         :modal-key="'resubscribe_with_pin'"
                 :hasExtraModalClass="'modal modal--welcomeback modal--zero-balance'"
                 :class-style="'modal__content modal_welcome modal_cont'"
         @close="close()">
    <!--    <div class="modal__content">-->
    <template slot="content">
      <div class="modal__header">

      </div>
      <div class="modal__body">
        <h1>{{ getTranslations.home_shortcut_text1 }}</h1>

        <p v-if="iOSdevice()">{{ getTranslations.home_shortcut_text2_ios }} </p>
        <p v-else>{{ getTranslations.home_shortcut_text2_android }}</p>
      </div>
      <div class="modal__footer" v-if="iOSdevice()">
        <div class="modal_two_btns">
          <a style="cursor:pointer" class="ti_btn--main"  @click="installiOSdevice()">{{ getTranslations.home_shortcut_button_ok }}</a>

        </div>

      </div>
      <div class="modal__footer" v-else>
        <div class="modal_two_btns">
          <a style="cursor:pointer" class="ti_btn--main" @click="install()" >{{ getTranslations.home_shortcut_button_yes }}</a>

        </div>
        <div class="modal_two_btns">
          <a style="cursor:pointer" class="ti_btn--main"  @click="close()" >{{ getTranslations.home_shortcut_button_no }}</a>
        </div>

      </div>


    </template>
    <!--    </div>-->
  </generic-modal>
</template>


<!--<template>-->
<!--  <div  v-if="visible">-->
<!--    <div class="modal modal&#45;&#45;welcomeback modal&#45;&#45;zero-balance " id="resubscribe_with_pin">-->
<!--    <div class="modal__content">-->
<!--      <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>-->
<!--      <div class="modal__header">-->

<!--      </div>-->
<!--      <div class="modal__body">-->
<!--        <h1>{{ getTranslations.home_shortcut_text1 }}</h1>-->

<!--        <p v-if="iOSdevice()">{{ getTranslations.home_shortcut_text2_ios }} </p>-->
<!--        <p v-else>{{ getTranslations.home_shortcut_text2_android }}</p>-->
<!--      </div>-->
<!--      <div class="modal__footer" v-if="iOSdevice()">-->
<!--        <div class="modal_two_btns">-->
<!--          <a style="cursor:pointer" class="ti_btn&#45;&#45;main"  @click="installiOSdevice()">{{ getTranslations.home_shortcut_button_ok }}</a>-->

<!--        </div>-->

<!--      </div>-->
<!--      <div class="modal__footer" v-else>-->
<!--        <div class="modal_two_btns">-->
<!--          <a style="cursor:pointer" class="ti_btn&#45;&#45;main" @click="install()" >{{ getTranslations.home_shortcut_button_yes }}</a>-->

<!--        </div>-->
<!--        <div class="modal_two_btns">-->
<!--          <a style="cursor:pointer" class="ti_btn&#45;&#45;main"  @click="$emit('close')" >{{ getTranslations.home_shortcut_button_no }}</a>-->
<!--        </div>-->

<!--      </div>-->


<!--    </div>-->
<!--  </div>-->
<!--  <div class="modal-overlay"></div>-->
<!--</div>-->
<!--</template>-->
<script>

import modals from '@/common/modals';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import BonusDaily from '../modals/bonus_phases/BonusDaily';
import GenericModal from '../sharedcomponents/GenericModal';


export default {
  name: 'home-screen-shortcut',
  components: { GenericModal },
  data() {
    return {
      showInstallButton: false,
      deferredPrompt: '',
      visible: true,
    };
  },
  beforeDestroy() {
    this.removeManifestLink();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'clearInstallPromptEvent',
      'storeHomeScreenModalDisable',
    ]),
    ...mapActions('common', [
      'phoneShortcutInstalled',
    ]),
    iOSdevice() {
      /* eslint-disable */

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        console.log('User is accessing from an iOS device');
        return true;
      }
      return false;
    },
    installiOSdevice() {
      this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
        localStorage.setItem('homeScreenModalApplied', 'true');
        this.visible = false;
        this.$emit('ok');
      });
    },
    close() {
      sessionStorage.setItem('homeScreenModalDenied', 'true');
      this.storeHomeScreenModalDisable(true);
      this.$emit('close');
      this.openDailyBonus();
    },
    openDailyBonus() {
      if (this.bonusDailyModal) {
        this.storeModalForHomePage(BonusDaily);
        modals.showHideModal(this);
      }
    },
    closeModal() {
      this.visible = false;
      this.openDailyBonus();
      this.$emit('ok');

      // window.removeEventListener('beforeinstallprompt', null);
    },
    beforeInstallPromptHandler(event) {
      // Prevent the default browser behavior to suppress the installation prompt
      event.preventDefault();
      // Store the event to prompt the user later
      console.log('EVENT', event);
      this.deferredPrompt = event;
    },
    removeManifestLink() {
      const manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        document.head.removeChild(manifestLink);
        this.clearInstallPromptEvent();
      }
    },
    install() {
      this.deferredPrompt = this.getInstallPromptEvent;
      if (this.deferredPrompt) {
        // Show the installation prompt
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            /* eslint-disable */
            console.log('User accepted the install prompt.');
            this.phoneShortcutInstalled({ shortcutCreated: true }).then(() => {
              localStorage.setItem('homeScreenModalApplied', 'true');
            });
          } else {
            /* eslint-disable */
            console.log('User dismissed the install prompt.');
            sessionStorage.setItem('homeScreenModalDenied', 'true');
          }
          // Clear the deferredPrompt variable to avoid multiple prompts
          // this.deferredPrompt = null;
        });
      }
      // Close the modal after the user responds to the prompt
      this.closeModal();
    },
  },
  computed: {
    ...mapState('common', [
      'installPromptEvent',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getInstallPromptEvent',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'firstTimeEntry',
      'notifications',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/HomeScreenShortcut.vue